module.exports = __webpack_public_path__ + "img/compareBI_3.b445359e.png";